import { Card, CardContent } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { EmailReportTemplateRow } from '@/models/emailReport'

function pct(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`
}

export function EmailTemplateBreakdown({ rows }: { rows: EmailReportTemplateRow[] }) {
  return (
    <Card>
      <CardContent className="p-4">
        <h2 className="mb-3 text-lg font-semibold">By template</h2>
        {rows.length === 0 ? (
          <div className="text-sm text-neutral-500">No emails in this range.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Template</TableHead>
                <TableHead className="text-right">Sent</TableHead>
                <TableHead className="text-right">Open rate</TableHead>
                <TableHead className="text-right">Click rate</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.templateId ?? '__none__'}>
                  <TableCell className={row.templateId ? 'font-medium' : 'text-neutral-500 italic'}>
                    {row.name}
                  </TableCell>
                  <TableCell className="text-right">{row.sent.toLocaleString()}</TableCell>
                  <TableCell className="text-right">{pct(row.openRate)}</TableCell>
                  <TableCell className="text-right">{pct(row.clickRate)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
